import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import { SUPPORTED } from "../i18n";
import { useLang } from "../lib/i18nContext";
import { EASE } from "../lib/motion";

// Small non-blocking suggestion pill. Never a modal, never blocking browsing.
const LanguageSuggestion = () => {
  const { t } = useTranslation();
  const { lang, suggestion, switchLang, dismissSuggestion } = useLang();
  const meta = SUPPORTED.find((l) => l.code === suggestion);
  const show = lang === "en" && suggestion && meta;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.5, ease: EASE }}
          data-testid="language-suggestion"
          className="fixed bottom-6 inset-x-4 sm:inset-x-auto sm:start-6 on-navy z-40 bg-ink text-white border border-white/15 rounded px-5 py-4 flex items-center gap-4"
          role="status"
        >
          <p className="text-sm whitespace-nowrap">{t("lang.suggestion", { language: meta.native })}</p>
          <div className="flex items-center gap-3 text-sm">
            <button
              onClick={() => switchLang(suggestion)}
              data-testid="suggestion-switch"
              className="font-semibold text-white underline underline-offset-4 hover:text-ice transition-colors duration-300 whitespace-nowrap"
            >
              {meta.native}
            </button>
            <span className="text-ice/60" aria-hidden="true">|</span>
            <button
              onClick={dismissSuggestion}
              data-testid="suggestion-continue-english"
              className="text-ice hover:text-white transition-colors duration-300 whitespace-nowrap"
            >
              {t("lang.continueEnglish")}
            </button>
          </div>
          <button
            onClick={dismissSuggestion}
            aria-label="Dismiss language suggestion"
            data-testid="suggestion-dismiss"
            className="text-ice hover:text-white transition-colors duration-300"
          >
            <X size={15} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LanguageSuggestion;
